import { render } from "./AsisConsAdmin.vue?vue&type=template&id=3799ad48"
import script from "./AsisConsAdmin.vue?vue&type=script&lang=js"
export * from "./AsisConsAdmin.vue?vue&type=script&lang=js"

import "./AsisConsAdmin.vue?vue&type=style&index=0&id=3799ad48&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__